var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5735H15M9 17.5735H12M4 4.57349V20.5735C4 21.1039 4.21071 21.6126 4.58579 21.9877C4.96086 22.3628 5.46957 22.5735 6 22.5735H18C18.5304 22.5735 19.0391 22.3628 19.4142 21.9877C19.7893 21.6126 20 21.1039 20 20.5735V8.91549C20 8.64905 19.9467 8.3853 19.8433 8.13973C19.7399 7.89416 19.5885 7.67173 19.398 7.48549L14.958 3.14349C14.5844 2.77814 14.0826 2.57355 13.56 2.57349H6C5.46957 2.57349 4.96086 2.7842 4.58579 3.15927C4.21071 3.53435 4 4.04305 4 4.57349Z",
    stroke: "#004181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.57349V6.57349C14 7.10392 14.2107 7.61263 14.5858 7.9877C14.9609 8.36277 15.4696 8.57349 16 8.57349H20",
    stroke: "#004181",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.625fad11d8d55547347d57e0739dd640.svg";
export { ForwardRef as ReactComponent };